import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Reconocer el anhelo sin asustarme",
    opening: localizedGenderNode(
      [
      "Hoy no intento borrar el anhelo. Lo reconozco — y me quedo.",
      "Me detengo conmigo."
    ],
      [
      "Hoy no intento borrar el anhelo. Lo reconozco — y me quedo.",
      "Me detengo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración lenta.",
      "Me digo por dentro: “Esto es anhelo. No es una orden.”"
    ],
      [
      "Una respiración lenta.",
      "Me digo por dentro: “Esto es anhelo. No es una orden.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\nMe pregunto:\n¿Qué siento ahora cuando aparece el anhelo? (una o dos palabras)",
      "Me pregunto:\n¿Dónde lo siento en el cuerpo?",
      "Si estoy dispuesto — dejo que el anhelo esté aquí durante 60 segundos, sin revisar, sin escribir, sin escapar. Solo observar.\n¿Qué pasó después de ese minuto?"
    ],
      [
      "Escritura\nMe pregunto:\n¿Qué siento ahora cuando aparece el anhelo? (una o dos palabras)",
      "Me pregunto:\n¿Dónde lo siento en el cuerpo?",
      "Si estoy dispuesto — dejo que el anhelo esté aquí durante 60 segundos, sin revisar, sin escribir, sin escapar. Solo observar.\n¿Qué pasó después de ese minuto?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El anhelo puede estar presente — y aun así me quedo conmigo."
    ],
      [
      "Cierre",
      "El anhelo puede estar presente — y aun así me quedo conmigo."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El impulso de contactar (y por qué aparece)",
    opening: localizedGenderNode(
      [
      "Hoy aprendo a pausar un impulso sin luchar contra él.",
      "Me detengo conmigo."
    ],
      [
      "Hoy aprendo a pausar un impulso sin luchar contra él.",
      "Me detengo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ],
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\nMe pregunto:\n¿Qué impulso aparece hoy? (escribir / revisar / mirar)",
      "Me pregunto:\n¿Qué intento calmar a través de este impulso?",
      "🔹 Protocolo de 90 segundos (desde hoy)\nCuando aparece un impulso:\n1. Tres respiraciones lentas\n2. Observar el cuerpo\n3. Una frase interna: “Esto es un impulso. Pasará.”\nLuego elijo una acción alternativa pequeña.\n¿Qué acción alternativa elijo hoy?"
    ],
      [
      "Escritura\nMe pregunto:\n¿Qué impulso aparece hoy? (escribir / revisar / mirar)",
      "Me pregunto:\n¿Qué intento calmar a través de este impulso?",
      "🔹 Protocolo de 90 segundos (desde hoy)\nCuando aparece un impulso:\n1. Tres respiraciones lentas\n2. Observar el cuerpo\n3. Una frase interna: “Esto es un impulso. Pasará.”\nLuego elijo una acción alternativa pequeña.\n¿Qué acción alternativa elijo hoy?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No tengo que actuar para que el impulso se calme."
    ],
      [
      "Cierre",
      "No tengo que actuar para que el impulso se calme."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Historia vs. hecho",
    opening: localizedGenderNode(
      [
      "Hoy separo lo que ocurrió de lo que mi mente cuenta."
    ],
      [
      "Hoy separo lo que ocurrió de lo que mi mente cuenta."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ],
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cuál es el hecho concreto que ocurrió? (sin interpretación)",
      "¿Qué historia construye mi mente alrededor de eso?",
      "¿Qué verdad suave puedo elegir hoy en lugar de la historia?"
    ],
      [
      "Escritura\n¿Cuál es el hecho concreto que ocurrió? (sin interpretación)",
      "¿Qué historia construye mi mente alrededor de eso?",
      "¿Qué verdad suave puedo elegir hoy en lugar de la historia?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No todo pensamiento es verdad. Algunos son dolor pidiendo atención."
    ],
      [
      "Cierre",
      "No todo pensamiento es verdad. Algunos son dolor pidiendo atención."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "La ola",
    opening: localizedGenderNode(
      [
      "El anhelo es una ola. Las olas pasan."
    ],
      [
      "El anhelo es una ola. Las olas pasan."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ],
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cómo es la ola para mí? ¿Cuándo llega?",
      "¿Qué me ayuda a sostener 10 minutos sin una acción dañina?",
      "¿Qué frase corta me digo en medio de una ola?"
    ],
      [
      "Escritura\n¿Cómo es la ola para mí? ¿Cuándo llega?",
      "¿Qué me ayuda a sostener 10 minutos sin una acción dañina?",
      "¿Qué frase corta me digo en medio de una ola?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No me mido por una ola."
    ],
      [
      "Cierre",
      "No me mido por una ola."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "La voz que acusa",
    opening: localizedGenderNode(
      [
      "Hoy cambio el castigo por un tono que me sostiene."
    ],
      [
      "Hoy cambio el castigo por un tono que me sostiene."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ],
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cuál es la frase acusadora que se repite?",
      "¿Cómo le hablaría a un amigo en mi lugar?",
      "¿Cómo suena esa misma frase en una versión más suave?"
    ],
      [
      "Escritura\n¿Cuál es la frase acusadora que se repite?",
      "¿Cómo le hablaría a un amigo en mi lugar?",
      "¿Cómo suena esa misma frase en una versión más suave?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Responsabilidad sin compasión no sana."
    ],
      [
      "Cierre",
      "Responsabilidad sin compasión no sana."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "A qué realmente extraño",
    opening: localizedGenderNode(
      [
      "Hoy desarmo el anhelo."
    ],
      [
      "Hoy desarmo el anhelo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ],
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Extraño a la persona / el hábito / el sueño?",
      "¿Qué puedo darme de eso — sin volver atrás?"
    ],
      [
      "Escritura\n¿Extraño a la persona / el hábito / el sueño?",
      "¿Qué puedo darme de eso — sin volver atrás?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El anhelo señala una necesidad, no una dirección."
    ],
      [
      "Cierre",
      "El anhelo señala una necesidad, no una dirección."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Exposición limpia (ACT suave)",
    opening: localizedGenderNode(
      [
      "Sostener el anhelo sin huir."
    ],
      [
      "Sostener el anhelo sin huir."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ],
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\nElijo un momento hoy para permitir que el anhelo esté aquí un minuto, sin acción.\n¿Qué pasó?",
      "¿Qué aprendí de mí en ese minuto?"
    ],
      [
      "Escritura\nElijo un momento hoy para permitir que el anhelo esté aquí un minuto, sin acción.\n¿Qué pasó?",
      "¿Qué aprendí de mí en ese minuto?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Soy fuerte no porque huí — sino porque me quedé."
    ],
      [
      "Cierre",
      "Soy fuerte no porque huí — sino porque me quedé."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Límites suaves",
    opening: localizedGenderNode(
      [
      "Un límite que me protege."
    ],
      [
      "Un límite que me protege."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ],
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Me pregunto:\n¿Qué acción aumenta el anhelo?",
      "Me pregunto:\n¿Qué límite pequeño estoy dispuesto a poner hoy?"
    ],
      [
      "Me pregunto:\n¿Qué acción aumenta el anhelo?",
      "Me pregunto:\n¿Qué límite pequeño estoy dispuesto a poner hoy?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Un límite es cuidado, no castigo."
    ],
      [
      "Cierre",
      "Un límite es cuidado, no castigo."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Si siguen adelante",
    opening: localizedGenderNode(
      [
      "Mi valor no depende del ritmo de nadie."
    ],
      [
      "Mi valor no depende del ritmo de nadie."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ],
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué hace esta imagen en mi cuerpo?",
      "¿Qué nueva verdad elijo sobre mi valor?"
    ],
      [
      "Escritura\n¿Qué hace esta imagen en mi cuerpo?",
      "¿Qué nueva verdad elijo sobre mi valor?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Me quedo conmigo — y eso es suficiente."
    ],
      [
      "Cierre",
      "Me quedo conmigo — y eso es suficiente."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "El cuerpo y el anhelo",
    opening: localizedGenderNode(
      [
      "El cuerpo sostiene la historia."
    ],
      [
      "El cuerpo sostiene la historia."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ],
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Dónde está tenso mi cuerpo hoy?",
      "¿Qué me está pidiendo?"
    ],
      [
      "Escritura\n¿Dónde está tenso mi cuerpo hoy?",
      "¿Qué me está pidiendo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Cuando calmo el cuerpo — el corazón respira."
    ],
      [
      "Cierre",
      "Cuando calmo el cuerpo — el corazón respira."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Recuperar control",
    opening: localizedGenderNode(
      [
      "Un paso."
    ],
      [
      "Un paso."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ],
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué está bajo mi control hoy? (tres cosas pequeñas)",
      "¿Qué paso doy?"
    ],
      [
      "Escritura\n¿Qué está bajo mi control hoy? (tres cosas pequeñas)",
      "¿Qué paso doy?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre"
    ],
      [
      "Cierre"
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "La noche",
    opening: localizedGenderNode(
      [
      "Detener bucles."
    ],
      [
      "Detener bucles."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ],
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cuál es mi bucle nocturno?",
      "¿Qué frase de cierre para la noche elijo?"
    ],
      [
      "Escritura\n¿Cuál es mi bucle nocturno?",
      "¿Qué frase de cierre para la noche elijo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Esta noche descanso."
    ],
      [
      "Cierre",
      "Esta noche descanso."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Ira",
    opening: localizedGenderNode(
      [
      "Ira sin destrucción."
    ],
      [
      "Ira sin destrucción."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ],
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿De qué me protege mi ira?",
      "¿Cómo la dejo salir sin hacer daño?"
    ],
      [
      "Escritura\n¿De qué me protege mi ira?",
      "¿Cómo la dejo salir sin hacer daño?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La ira puede convertirse en una fuerza que ordena."
    ],
      [
      "Cierre",
      "La ira puede convertirse en una fuerza que ordena."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Ritual de liberación y cierre",
    opening: localizedGenderNode(
      [
      "Cerrar un capítulo sin borrarlo."
    ],
      [
      "Cerrar un capítulo sin borrarlo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ],
      [
      "Me detengo un momento conmigo.",
      "Una inhalación lenta… una exhalación lenta…",
      "Una más.",
      "Siento mi cuerpo aquí, ahora.",
      "No tengo que resolver nada ahora — solo estar."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Me pregunto:\n¿Qué cambió en mí en este recorrido?",
      "Me pregunto:\n¿Cuál es mi “frase de camino” para días difíciles?"
    ],
      [
      "Me pregunto:\n¿Qué cambió en mí en este recorrido?",
      "Me pregunto:\n¿Cuál es mi “frase de camino” para días difíciles?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final del viaje",
      "No borro el anhelo —",
      "dejo de permitir que dirija mi vida.",
      "Sigo caminando —",
      "despacio, en silencio, conmigo.",
      "Y eso es fuerza."
    ],
      [
      "Cierre final del viaje",
      "No borro el anhelo —",
      "dejo de permitir que dirija mi vida.",
      "Sigo caminando —",
      "despacio, en silencio, conmigo.",
      "Y eso es fuerza."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
].map(buildNormalizedDay);

export const obsessiveLongingBlueprintEs = buildNormalizedPilotBlueprint({
  id: "obsessive_longing_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "obsessive_longing",
  category: "general",
  journeyName: {
    he: "",
    en: "Obsessive longing that won’t let go",
    es: "",
  },
  days,
});

export default obsessiveLongingBlueprintEs;
